const testimonials = [
  {
    id: 1,
    name: 'Shaikh Arfan',
    title: 'student',
    org: 'J Spider',
    desc: 'Aziz is a person of commitment. He is really good at what he is doing. I really like his work. Especially the unique point of view of designing.',
  },
  {
    id: 2,
    name: 'Fahim Elahe',
    title: 'Co-founder',
    org: 'Kreetive',
    desc: 'Really amazing communication skills. Always understand what I am trying to achieve. Also, his work is really amazing. Do really high-quality work.',
  },
  {
    id: 3,
    name: 'Sayed',
    title: 'Marketing Head',
    org: 'Eleven Dawn',
    desc: 'Really hard-working person. Deliver the work as promised. Planning to work more with this person.',
  },
];
export default testimonials;
